import * as types from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  user: [],
  error: null,
};

const VendorResolveProofreaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.VENDOR_RESOLVE_PROOFREADER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.VENDOR_RESOLVE_PROOFREADER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.VENDOR_RESOLVE_PROOFREADER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default VendorResolveProofreaderReducer;
